import { render } from "./SpaceSearch.vue?vue&type=template&id=44b481c8&scoped=true&ts=true"
import script from "./SpaceSearch.vue?vue&type=script&lang=ts"
export * from "./SpaceSearch.vue?vue&type=script&lang=ts"

import "./SpaceSearch.vue?vue&type=style&index=0&id=44b481c8&lang=scss&scoped=true"
import "./SpaceSearch.vue?vue&type=style&index=1&id=44b481c8&lang=scss"

import exportComponent from "/Users/wangyong/shanggeyun/code/sagacloud-sagacare-ipad/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b481c8"]])

export default __exports__